"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClockIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ClockIcon = exports.ClockIcon = function ClockIcon(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "black" : _ref$color;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: color,
      clipPath: "url(#clip0_196_3015)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M24 4.5a1 1 0 01-2 0A2.592 2.592 0 0019.215 2a1 1 0 110-2A4.6 4.6 0 0124 4.5zM2 4.5A2.59 2.59 0 014.785 2a1 1 0 000-2A4.6 4.6 0 000 4.5a1 1 0 002 0zM20.32 20.176A10.98 10.98 0 0013 2.051V1a1 1 0 00-2 0v1.051a10.98 10.98 0 00-7.319 18.125A3.024 3.024 0 002 23a1 1 0 102 0 1.2 1.2 0 011.11-1.229.933.933 0 00.2-.062 10.924 10.924 0 0013.39 0c.059.027.12.048.182.064A1.2 1.2 0 0120 23a1 1 0 102 0 3.025 3.025 0 00-1.68-2.824zm-4.613-4.469a1 1 0 01-1.414 0l-3-3A1 1 0 0111 12V7a1 1 0 112 0v4.586l2.707 2.707a1 1 0 010 1.414z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_196_3015",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H24V24H0z"
        })
      })
    })]
  });
};